export const TimeUtil = Object.freeze({
  /** 将秒、毫秒混乱的时间戳修正成毫秒 */
  fixChaosMillis(timestamp) {
    const boundary = 10000000000; // 按秒解释是2286-11-21，毫秒是1970-04-27
    return Number(timestamp) < boundary
      ? timestamp * 1000
      : timestamp;
  },
});
